import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { IDebtPaymentPlanOptions } from "./debtPaymentPlanOptions.types"
import { DebtPaymentPlanOptions } from "./debtPaymentPlanOptions"
import { GetPaymentPlanOptionsResponse } from "@/api/backofficeRest/generated/model"

export type DebtPaymentPlanOptionsRaw = GetPaymentPlanOptionsResponse

export const DebtPaymentPlanOptionsParser: IParser<
  IDebtPaymentPlanOptions,
  DebtPaymentPlanOptionsRaw
> = {
  toDomain: (data: DebtPaymentPlanOptionsRaw) => {
    try {
      return new DebtPaymentPlanOptions(
        Number(data.fuelMonthlyPayment ?? 0),
        data.maxPlanLengthInMonths ?? 0,
        data.minPlanLengthInMonths ?? 0,
        data.maxPlanLengthWithApprovalInMonths ?? 0,
        data.recommendedPlanLengthsInMonths ?? [],
        Number(data.totalDebt),
        data.planType ?? null,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
